'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.flkty = undefined;

var _setup = require('./setup.js');

var flkty = exports.flkty = null;

var grillMultiplier = 0.3;
var auximgMultiplier = 0.2;
var bodyMultiplier = 0.1;

var $meterFill = $('#nx-homehero-meter-fill');

var meterInit = false;
var slidesLoaded = [];
var hasScrolledSlider = false;

function heroCarousel() {
	if (!_setup.s.$herocarousel.length) return;

	//init
	exports.flkty = flkty = _setup.s.$herocarousel.flickity({
		slideSelector: '.nx-homehero--slide',
		setGallerySize: false,
		wrapAround: false,
		pageDots: false,
		prevNextButtons: false,
		dragThreshold: Modernizr && Modernizr.touchevents ? 25 : 2,
		bgLazyLoad: true,
		selectedAttraction: 0.025,
		friction: 0.28
	}).data('flickity');

	// controls & arrows
	var $rarr = _setup.slider.getSliderBtnHtml('Next', 'nx-homehero-nextbtn');
	var $larr = _setup.slider.getSliderBtnHtml('Prev', 'nx-homehero-prevbtn');
	_setup.s.$homeheroControls.prepend($rarr, $larr);

	$rarr.click(function () {
		return _setup.s.slideNextHandler(flkty);
	});
	$larr.click(function () {
		return _setup.s.slidePrevHandler(flkty);
	});

	//on drag/scroll
	flkty.on('scroll', function (progress) {
		var fullPercent = (flkty.cells.length - 1) * 100 * progress;
		TweenMax.set(_setup.s.$herocarouselMeterfill, { x: fullPercent + '%' });

		flkty.slides.forEach(function (slide, i) {
			var xdiff = slide.target + flkty.x;
			var $slide = $(_setup.s.$herocarouselSlides[i]);
			var $singleGrill = $slide.find('.nx-homehero--grillimg');
			var $storyImg = $slide.find('.nx-homehero--auximg');
			var $copy = $slide.find('.nx-homehero--copy');

			TweenMax.set($copy, { x: xdiff * bodyMultiplier });
			if ($singleGrill.length) {
				TweenMax.set($singleGrill, { x: xdiff * grillMultiplier });
			}
			if ($storyImg.length) {
				TweenMax.set($storyImg, { x: xdiff * auximgMultiplier });
			}
		});

		if (!hasScrolledSlider) {
			hasScrolledSlider = true;
		}
	}); //end on slider scroll

	//on slide select - lazy load slide backgrounds
	flkty.on('select', function () {
		var allDone = slidesLoaded.length === _setup.s.$herocarouselSlides.length;
		var hasImg = slidesLoaded.indexOf(flkty.selectedIndex) > -1;
		if (allDone || hasImg) {
			return;
		}

		lazyLoadSlideBg(flkty.selectedIndex);
		slidesLoaded.push(flkty.selectedIndex);
	});
	lazyLoadSlideBg(0);

	//other slider ui
	meterStateHandler.call();
	videoSlideEventTrigger.call();
};

//lazy load slide by index
function lazyLoadSlideBg(slideNum) {
	var $els = _setup.s.$herocarouselSlides.eq(slideNum).find('[data-flickity-bg-lazyload]');

	$els.each(function () {
		var $t = $(this);
		var imgurl = $t.data('flickity-bg-lazyload');
		$('<img/>').on('load', function () {
			return $t.addClass('is-hero-lazyloaded');
		}).attr({ src: imgurl });
		$t.css({ backgroundImage: 'url(' + imgurl + ')' });
	});
};

//trigger click on normal play button when text link is clicked
function videoSlideEventTrigger() {
	var $vidslides = _setup.s.$herocarousel.find('.is-video-slide');

	$vidslides.each(function (i, item) {
		var $this = $(item);
		var $link = $this.find('.nx-btn--link');
		var $btn = $this.find('[data-video-type]');
		var $btnParent = $btn.parent('.nx-playbtn');

		$link.hover(function () {
			return $btnParent.addClass('is-hovering');
		}, function () {
			return $btnParent.removeClass('is-hovering');
		});
		//.click(() => $btn.trigger('click'));
	});
};

function meterLinkSetup(size) {
	var html = '<ul class="nx-slidemeter--links">';
	for (var i = 0; i < flkty.cells.length; i++) {
		html += '<li></li>';
	}
	html += '</ul>';
	_setup.s.$herocarouselMeter.append(html);

	var $slideLinks = _setup.s.$herocarouselMeter.find('li');
	$slideLinks.css({ width: size });

	$slideLinks.each(function (i, item) {
		$(this).click(function () {
			return flkty.select(i);
		});
	});
};

function meterStateHandler() {
	if (!meterInit) {
		var meterMax = 1 / flkty.cells.length * 100;
		var metersize = meterMax + '%';
		_setup.s.$herocarouselMeterfill.css({ width: metersize });
		meterLinkSetup(metersize);
		meterInit = true;
	}
};

//unused - will add disabled state to btns
//flkty.on('select', btnStateHandler)
function btnStateHandler() {
	if (flkty.selectedIndex === 0) {
		_setup.s.$herocarouselPrev.attr('disabled', true);
	} else {
		_setup.s.$herocarouselPrev.removeAttr('disabled');
	}
	if (flkty.selectedIndex === flkty.cells.length - 1) {
		_setup.s.$herocarouselNext.attr('disabled', true);
	} else {
		_setup.s.$herocarouselNext.removeAttr('disabled');
	}
};

heroCarousel.call();


//////////////////
// WEBPACK FOOTER
// ./_js/hero-carousel.js
// module id = 15
// module chunks = 0